<template>
  <div class="wxtip" v-show="showTip">
    <van-icon name="share" class="wxtip-icon" color="#fff"/>
    <p class="wxtip-txt">点击右上角<br />选择在浏览器中打开</p>
  </div>
</template>

<script>
import util from "@/utils/util";
export default {
  data() {
    return {
      showTip: false,
    };
  },
  created() {
    const { userAgent } = window.navigator;
    const isWeixin = !!/MicroMessenger/i.test(userAgent);
    if (isWeixin) {
      //如果是微信环境，就弹出遮罩层
      this.showTip = true;
    }
    const selectId = util.getUrlKey("selectId");
    // app = url.replace(url.slice(0, 5) === "https" ? "https" : "http", "app");
    window.location.href = `app://com.haier.rrs.driver/data?page=course&selectId=${selectId}`;
  },
};
</script>

<style lang="scss" scoped>
.wxtip {
  background: rgba(0, 0, 0, 0.8);
  text-align: center;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 998;
}
.wxtip-icon {
  width: 52px;
  height: 67px;
  display: block;
  position: absolute;
  right: 6px;
  top: 6px;
}
.wxtip-txt {
  margin-top: 107px;
  color: #fff;
  font-size: 16px;
  line-height: 1.5;
}
</style>
